module.exports = __webpack_public_path__ + "static/media/checklist.7bd61f76.svg";